import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { ApiCategoryList, ApiCategorySeoId } from 'idt-ecommerce-api/_api/api-catalog/api-categories/api-categories.models';
import { ApiRequestService } from 'idt-ecommerce-api/_api/api-util/api-request.service';
import { RenderSetupDataService } from 'idt-ecommerce-api/render-setup-data/render-setup-data.service';


/**
* @deprecated {@link ApiCategoriesServiceInterface} is deprecated. Use
* {@link ApiNavigationStorefrontService} from `api-navigation-storefront.service` instead.
* Will be removed when ITX Rest API is fully decommissioned.
*/
export interface ApiCategoriesServiceInterface {
  categories(storeId: string, catalogId: string, languageId: string): Observable<ApiCategoryList>;
  findCategoryFromSeoId(
    storeId: string,
    catalogId: string,
    seoId: string,
    languageId: string
  ): Observable<ApiCategorySeoId>;
}

/**
 * @deprecated Use {@link ApiNavigationStorefrontService} from
 * `api-navigation-storefront.service` instead. Will be removed when ITX Rest API is fully decommissioned.
 */
@Injectable()
export class ApiCategoriesService implements ApiCategoriesServiceInterface {

  constructor(
    private readonly renderSetupDataService: RenderSetupDataService,
    private readonly http: HttpClient,
    private readonly requestService: ApiRequestService
  ) {}

  public categories(
    storeId: string,
    catalogId: string,
    languageId: string,
    cache: boolean = false
  ): Observable<ApiCategoryList> {
    if (this.renderSetupDataService.categories) {
      return of(this.renderSetupDataService.categories);
    }

    const iCategoryTreeJSON = sessionStorage.getItem('iCategoryTreeJSON');
    if (iCategoryTreeJSON) {
      return of(JSON.parse(iCategoryTreeJSON));
    }
    const headers = this.settingHeaders(cache);
    return this.requestService.requestUrl(`catalog/store/${storeId}/${catalogId}/category`, languageId).pipe(
      switchMap((url: string) => this.http.get<ApiCategoryList>(url, { headers }))
    );
  }

  public findCategoryFromSeoId(
    seoId: string,
    storeId: string,
    catalogId: string,
    languageId: string,
    cache: boolean = false
  ): Observable<ApiCategorySeoId> {
    const headers = this.settingHeaders(cache);
    return this.requestService.requestUrl(`catalog/store/${storeId}/${catalogId}/mapper/category/seo-id/${seoId}`, languageId).pipe(
      switchMap((url: string) => this.http.get<ApiCategorySeoId>(url, { headers }))
    );
  }

  private settingHeaders(cache: boolean): HttpHeaders {
    let headers: HttpHeaders = new HttpHeaders();
    if (cache) {
      headers = headers.append('cache-response', 'true');
    }
    return headers;
  }

}
